<template>
  <div class="announce-banner">
    <div class="item-left"></div>
    <div class="item-right">
      <h3><span>Major new update is coming to this </span>
      <span>Prosper Africa Virtual Deal Room.</span></h3>
      <p class="preview-link"><a href="https://prosperafrica-v2.asokoinsight.com" target="_blank">Preview Beta version 2.0</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'announce-banner'
}
</script>

<style lang="scss" scoped>
.announce-banner {
  background: #F9FAFB;
  border-radius: 6px;
  display: flex;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  .item-left {
    height: 300px;
    width: 300px;
    background-size: cover;
    background-image: url('../../assets/img/announce.png');
    @media (min-width: 1024px) {
      width: 434px;
    }
  }
  .item-right {
    padding-top: 65px;
    padding-left: 60px;
    padding-right: 20px;
  }
  h3 {
    display: flex;
    flex-direction: column;
    color: #334F7C;
    font-weight: 500;
    font-size: 24px;
    @media (min-width: 1024px) {
      font-size: 28px;
      line-height: 34px;
    }
  }
  .preview-link {
    margin-top: 20px;
    color: #0083FD;
    font-weight: 400;
    font-size: 22px;
    line-height: 27px;
    text-decoration: underline;
  }
}
</style>
